export const ActionTypes = {
  LOADING: "SIGN_IN_LOADING",
  ERROR: "SIGN_IN_ERROR",
  SUCCESS: "SIGN_IN_SUCCESS",
};
